import { AccessoryType } from '../enums';
import { StudyUnitDto } from '../models';

/**
 * Whether "add to quote" is closed on a good-for-selection card: the unit must carry the base accessory
 * (`AccessoryType.DASH`) and nothing in the pairing may have a configuration error. Ported from the legacy
 * card's `isAddDisabled` (`good-for-selection-card.component.ts:52-66`) so both pages gate the same way.
 * It lives here rather than on the new card because `project-feature-study-next` has no test target.
 *
 * The base accessory is looked for on the unit only, as on legacy — an external unit carrying one does not
 * open the gate.
 */
export function isAddToQuoteDisabled(unit: StudyUnitDto, externalUnit: StudyUnitDto | null | undefined): boolean {
  const unitAccessories = Object.values(unit.accessories);
  const externalUnitAccessories = Object.values(externalUnit?.accessories ?? {});

  if (!unitAccessories.some(accessory => accessory.type === AccessoryType.DASH)) {
    return true;
  }

  return (
    unit.configErrorCode != null ||
    externalUnit?.configErrorCode != null ||
    unitAccessories.some(accessory => accessory.configErrorCode != null) ||
    externalUnitAccessories.some(accessory => accessory.configErrorCode != null)
  );
}
